// Enum per la modalit� di acquisto
export enum ModalitaAcquisto {
    PerSocieta = "PerSocieta",
    PerProcura = "PerProcura",
    InComproprieta = "InComproprieta",
    DaTutore = "DaTutore"
}

// Enum per il tipo di persona
export enum TipoPersona {
    Fisica = "fisica",
    Giuridica = "giuridica"
}

// Base class comune
export abstract class SoggettoBase {
    constructor(
        public tipoPersona: TipoPersona,
        public statoResidenza: "ita" | "estero",
        public luogoNascita: "ita" | "estero",
        public modalitaAcquisto: ModalitaAcquisto
    ) {}
}

// Persona Giuridica
export class SoggettoGiuridico extends SoggettoBase {
    constructor(modalitaAcquisto: ModalitaAcquisto) {
        super(TipoPersona.Giuridica, "ita", "ita", modalitaAcquisto);
    }
}

// Persona Fisica
export class SoggettoFisico extends SoggettoBase {
    constructor(modalitaAcquisto: ModalitaAcquisto) {
        super(TipoPersona.Fisica, "ita", "ita", modalitaAcquisto);
    }
}